export default "__VITE_ASSET__4131267e__"